import { createListSlice } from 'redux/utils'

const slice = createListSlice('Favourite')
export const { actions } = slice
export default slice.reducer
